import { Skeleton } from '@mantine/core'
import { useStatsigClient } from '@statsig/react-bindings'
import { Axios } from 'cms-api'
import React from 'react'
import { getPublicLayout } from '@public/components/PublicLayout'
import Home, { getStaticProps as getHomeStaticProps } from '@public/Home'
import { Homepage } from '@public/Homepage'
import { Flex } from 'components/Layout'
import { HERO_CAROUSEL_HEIGHT } from 'components/Widgets'
import { STRAPI_WIDGETS } from 'constants/common'

const Page = (props: any) => {
  const { client } = useStatsigClient()

  if (client.loadingStatus !== 'Ready') {
    return (
      <Flex
        position="relative"
        height={HERO_CAROUSEL_HEIGHT}
        alignItems="center"
        justifyContent="center"
      >
        {/* Main skeleton block */}
        <Skeleton height="100%" width="100%" radius="sm" />
      </Flex>
    )
  }

  const experiment = client.getExperiment('homepage')
  const variant = experiment.get('homepage_variant', 'control')

  return variant === 'test' ? (
    <Homepage homepageData={props.strapiHomepageWidgets} />
  ) : (
    <Home {...props} />
  )
}

export async function getStaticProps(context) {
  const strapiHomepageWidgets = await Axios.client().getHomepage({
    populate: {
      widgets: {
        on: {
          [STRAPI_WIDGETS.TRADE_ADVANTAGES_WIDGET]: {
            populate: '*',
          },
          [STRAPI_WIDGETS.HERO_WIDGET]: {
            populate: '*',
          },
          [STRAPI_WIDGETS.EXPERT_TESTIMONIALS_WIDGET]: {
            populate: {
              testimonials: {
                populate: '*',
              },
            },
          },
          [STRAPI_WIDGETS.BRANDS_WIDGET]: {
            populate: {
              brands: {
                populate: '*',
              },
            },
          },
          [STRAPI_WIDGETS.FEATURED_EXPERTS_WIDGET]: {
            populate: {
              experts: {
                populate: '*',
              },
            },
          },
          [STRAPI_WIDGETS.TRENDING_PRODUCTS_WIDGET]: {
            populate: {
              products: {
                populate: {
                  product: {
                    populate: {
                      images: true,
                      productVariants: {
                        populate: {
                          images: true,
                          leadProductImage: true,
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          [STRAPI_WIDGETS.FEATURED_CATEGORIES_WIDGET]: {
            populate: {
              categories: {
                populate: '*',
              },
            },
          },
        },
      },
    } as never,
  })
  const baseProps = await getHomeStaticProps(context)

  const { props, revalidate, ...rest } = baseProps

  const combinedProps = {
    props: { ...props, strapiHomepageWidgets },
    revalidate: 600,
    ...rest,
  }

  return combinedProps
}

Page.getLayout = (page: React.ReactElement) =>
  getPublicLayout(page, { isFullWidth: true })

export default Page
